import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/dashboard.service';
import { PostCard } from 'src/app/dashboard';
import {ReportService} from '../../services/report/report.service';

import { CompanyService } from '../../services/Company/company.service';


@Component({
  selector: 'app-recent-post-cards',
  templateUrl: './recent-post-cards.component.html',
  styleUrls: ['./recent-post-cards.component.scss']
})
export class RecentPostCardsComponent implements OnInit {
  postCards: PostCard[] = [];
  currentCompany:any = [];
  constructor(private dashboardService: DashboardService,private companyService:CompanyService, private reportService:ReportService) { 

    this.currentCompany = companyService.getCurrentCompany();

    
    if (this.currentCompany) {
      //this.getStats();
    }

  }

  ngOnInit() {
    //this.getRecentPosts();
  }

  getRecentPosts() {
    this.dashboardService.getPostCards()
      .subscribe(postCards => {
        this.postCards = postCards.slice(0, 3);
      });
  }

}
